module.exports = __webpack_public_path__ + "img/index-logo-dark.7f49c959.png";